<template>
  <DropdownMenuRoot
    v-if="forceFloating || !isMobile"
    :modal="false"
    :open="open"
    @update:open="open = $event"
  >
    <slot></slot>
  </DropdownMenuRoot>
  <DrawerRoot v-else>
    <slot></slot>
  </DrawerRoot>
</template>

<script setup lang="ts">
import { DropdownMenuRoot } from "radix-vue";
import { DrawerRoot } from "vaul-vue";
import { onMounted, ref } from "vue";

import { useMediaQuery } from "@/lib/media_query";

import { provide } from "./context";

const isMobile = useMediaQuery("(width < 768px) and (pointer: coarse)");

const props = defineProps<{
  forceFloating?: boolean;
  id?: string;
}>();

const open = ref(false);
onMounted(() => {
  // If this element is emphasized, open the menu.
  const emphasisQueryParameter =
    new URLSearchParams(window.location.search).get("emphasis") === props.id;
  if (emphasisQueryParameter) {
    open.value = true;
  }
});

provide({
  isNested: false,
  get isMobile() {
    return !props.forceFloating && isMobile.value;
  },
});
</script>
